import axios from 'axios';
import EnumData = App.Base.Data.EnumData;

export async function index(): Promise<EnumData[]> {
  return axios.get(route('api.sms.inbound-message-types.index')).then((res) => res.data);
}
